import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"padding":"0 40px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "comment-block" }
const _hoisted_5 = { class: "comment-content" }
const _hoisted_6 = { class: "comment-project" }
const _hoisted_7 = {
  key: 1,
  style: {"margin-top":"1rem","margin-bottom":"1rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Loading, {
      ref: "loading",
      minHeight: "40vh",
      enableOnScrollEnd: true,
      onOnscrollend: _ctx.onScrollEnd
    }, {
      default: _withCtx(() => [
        (_ctx.commentList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentList, (comment) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: comment.id,
                  style: {"display":"flex","padding":"8px"}
                }, [
                  _createElementVNode("img", {
                    style: {"border-radius":"50%","width":"50px","height":"50px"},
                    src: _ctx.urls.getUserImageSrc(_ctx.user),
                    alt: _ctx.user.userName
                  }, null, 8, _hoisted_3),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(comment.comment), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_router_link, {
                        to: `/${comment.publicPage.user.userName}/${comment.publicPage.titleURL}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(comment.publicPage.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("h5", _hoisted_7, "コメントはありません"))
      ]),
      _: 1
    }, 8, ["onOnscrollend"])
  ]))
}